export default {
  MuiTextField: {
    defaultProps: {
      fullWidth: true,
      variant: "outlined",
    },
  },
};
